export class Users {
  id: number;
  username: string;
  firstname: string;
  lastname: string;
  profile: string;
  email: string;
  systems: string;

  constructor(
    id: number,
    username: string,
    firstname: string,
    lastname: string,
    profile: string,
    email: string,
    systems: string
  ) {
    this.id = id;
    this.username = username;
    this.firstname = firstname;
    this.lastname = lastname;
    this.profile = profile;
    this.email = email;
    this.systems = systems;
  }
}
